import * as React from "react";
import {hasConsultantLevelAccess} from "../../utils/sessionUtil";
import {ErrorComponent} from "../base/Error.component";

export const VideoPage: React.FunctionComponent<{}> = () => {
    if (!hasConsultantLevelAccess()) {
        return <ErrorComponent/>;
    }

    const iframe = <iframe style={{
        display: "block",
        border: "none",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        height: "100%",
    }}
   src="https://players.brightcove.net/1509269527/experience_5cb8d4443530ca0023d372ab/index.html"
   allow="autoplay; fullscreen; geolocation; encrypted-media"
   allowFullScreen={true}
    />;

    return <div
        className={"video-demo"}
        style={{ height: 1000 }}
    >
        {iframe}
    </div>;
};

export default VideoPage;
